import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidenavbar";
import Header from "./Headernavbar";
import "../dashboardlayout.css";

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  return (
    
    <div className={`dashboard ${collapsed ? "collapsed" : ""}`}>

   
      <Sidebar
        open={sidebarOpen}
        collapsed={collapsed}
         toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="main">
        <Header
          toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          toggleCollapse={() => setCollapsed(!collapsed)}
          sidebarOpen={sidebarOpen}
        />

        <div className="content">
          <Outlet />
        </div>

      </div>
    </div>
  );
}